import React, { PropsWithChildren } from 'react';

import { defaultTheme } from '../theme';
import { IconProps } from '../types';

import { IconStyle } from './styles';

const IconWrapper: React.FC<PropsWithChildren<IconProps>> = ({
  isActive = false,
  disabled = false,
  height = '21px',
  width = 'auto',
  ...props
}) => {
  const theme = { ...defaultTheme, ...props.theme };
  if (!theme.secondaryColor) {
    theme.secondaryColor = theme.color;
  }
  if (!theme.secondaryActiveColor) {
    theme.secondaryActiveColor = theme.activeColor;
  }
  if (!theme.secondaryDisabledColor) {
    theme.secondaryDisabledColor = theme.disabledColor;
  }

  return (
    <IconStyle
      $disabled={disabled}
      $height={height}
      $isActive={isActive}
      $theme={theme}
      $width={width}
      className={props.ignoreHoverStyles ? 'ignoreHoverStyles' : undefined}
    >
      {props.children}
    </IconStyle>
  );
};

export default IconWrapper;
